import { MapIcon, SearchIcon, TrendingUpIcon, ClipboardCheckIcon, MessageCircleIcon, CalendarIcon } from 'lucide-react';

export const bonuses = [
  {
    icon: MapIcon,
    emoji: '🗺️',
    title: 'Mapa Rápido para Armar Clases en 10 Minutos',
    value: '19€',
    text: 'Convertí cualquier ejercicio en una clase ordenada, profesional y lista para dar. Framework comprobado: entrada → movilidad → abdomen → principal → integración → cierre.',
    items: ['5 intenciones de clase claras', 'Fórmula de selección de ejercicios', 'Plantilla imprimible', '3 ejemplos listos para usar']
  },
  {
    icon: SearchIcon,
    emoji: '🔍',
    title: 'Selector de Ejercicios por Objetivo y Nivel',
    value: '19€',
    text: 'Encontrá el ejercicio correcto en 30 segundos. Selector por objetivo (abdomen, movilidad, glúteos, postura, respiración) y nivel (inicial, intermedio, avanzado).',
    items: ['Tablas de consulta rápida', 'Matriz de decisión', 'Versión móvil imprimible', 'Cero improvisación']
  },
  {
    icon: TrendingUpIcon,
    emoji: '📈',
    title: 'Guía de Progresiones y Regresiones',
    value: '19€',
    text: 'Adaptá cualquier ejercicio en segundos. Los 5 niveles de adaptación: reducir rango, flexionar rodillas, agregar apoyo, cambiar base, agregar inestabilidad.',
    items: ['5 niveles para cada ejercicio', 'Checklist antes de progresar', 'Frases profesionales', 'Protocolo de 3 pasos']
  },
  {
    icon: ClipboardCheckIcon,
    emoji: '✅',
    title: 'Checklist de Correcciones Profesionales',
    value: '19€',
    text: 'Detectá errores técnicos al instante. Los 10 errores más comunes y cómo corregirlos sin parar la clase. Frases listas, protocolos claros.',
    items: ['Los 10 errores más frecuentes', 'Cómo observar como profesora', '30+ frases de corrección listas', 'Protocolo en tiempo real']
  },
  {
    icon: MessageCircleIcon,
    emoji: '💬',
    title: 'Guiones de Cues Profesionales',
    value: '19€',
    text: 'Hablá como una profesora experta. 50+ cues por zona corporal, guiones de apertura y cierre, banco de imágenes verbales poderosas. Nunca más te quedés sin palabras.',
    items: ['Cues probados por zona', 'Guiones de apertura (5 versiones)', 'Guiones de cierre (5 versiones)', 'Cómo construir tus propios cues']
  },
  {
    icon: CalendarIcon,
    emoji: '📅',
    title: 'Planificador de Clases y Rotación de Repertorio',
    value: '19€',
    text: 'Evitá repeticiones y mantené alumnas motivadas. Sistema de 5 semanas, tracker de ejercicios, checklist post clase, plantillas para grupal e individual.',
    items: ['Sistema de 5 semanas de rotación', 'Tracker de uso de ejercicios', 'Plantillas imprimibles', 'Cómo evitar repeticiones']
  }
];
